import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { PublicUserDto } from '../../../commonTypes/user.types';

const useHttpGetUsersByRoleOnMount = (roleNames: string[]) => {
    const userApi: UserApi = useContainer(UserApi);
    const [users, setUsers] = useState<PublicUserDto[]>([]);
    const [isReady, setIsReady] = useState(false);

    const getUserByRole = (roleNames: string[]) => {
        const { exec, abort } = userApi.getUsersByRole({
            body: { roleNames },
            onSuccess: res => {
                setUsers(res.body);
            },
            onError: error => console.error(error),
            onFinally: () => {
                setIsReady(true);
            },
        });
        exec();
        return abort;
    };

    useEffect(() => {
        if (roleNames.length) getUserByRole(roleNames);
    }, []);

    return { isReady, users };
};

export default useHttpGetUsersByRoleOnMount;
